import React, {useEffect, useRef,useState } from "react"; 
import { toast } from 'react-toastify';
import Form from 'react-bootstrap/Form';
import { Button, Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { createUser, updateUser,getUserByID, fetchStates } from "../../../../Services/User/User";
const CreateUser = ({ isShow, close, type, userId }) => {  
  const handleShow = () => setShow(true);
  const handleClose = () => {setShow(false);close()};
  const [show, setShow] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState(""); 
  const [mobileNo, setMobileNo] = useState("");
  const [password, setPassword] = useState("");
  const [userNameError, setuserNameError] = useState(false);
  const [mobileNumberError, setMobileNumberError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false); 
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false); 
  const [status, setStatus] = useState();
  const usernameRef = useRef(null);
  const mobileNumberRef = useRef(null);
  const emailRef = useRef(null);
  const [passwordShow, setPasswordShow] = useState(false);
  const [address, setAddress] = useState("");
  const [selectedStateId, setSelectedStateId] = useState("");
  const [stateData, setStateData] = useState([]);
  const [deviceLimit, setDeviceLimit] = useState(1);
  const [stateName, setStateName] = useState("");
  const [addressError, setAddressError] = useState(false);
  const [stateError, setStateError] = useState(false);
  const addressRef = useRef(null);
  const cityRef = useRef(null);
  const pincodeRef = useRef(null);
  const [city, setCity] = useState('');
  const [pincode, setPincode] = useState('');
  const [cityError, setCityError] = useState(false);
  const [showUpdatePassword, setShowUpdatePassword] = useState(false);
  const [pincodeError, setPincodeError] = useState(false);
  const passwordRef = useRef(null);
     const handlePasswordShow = (e) => {
        if (e.target.checked) {
            setPasswordShow(true)
        } else {
            setPasswordShow(false)
        }
    };
  useEffect(() => {
    setShow(isShow)
    fetchStates().then((response) => {
      setStateData(response?.data?.data || []);
    });
  }, []);
  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const response = await getUserByID(userId);
        if (response?.status) {
          const user = response.data.user;
          setName(response.data.user.display_name);
          setEmail(response.data.user.email);
          setMobileNo(response.data.user.mobile_number);
          setStatus(response.data.user.active)
          setDeviceLimit(response.data.user.device_limit||"")
          if (response.data.user.addresses) {
            setSelectedStateId(user.addresses.state_id);
            setAddress(response.data.user.addresses.address || "")
            setCity(response.data.user.addresses.city || "")
            setPincode(response.data.user.addresses.pincode || "")
          }

        }
      } catch (error) {
        toast.error("Error fetching user details");
      }
    };

    if (type === "EDIT" && isShow) {
      fetchUserDetails();
    }
  }, [type, userId, isShow]);
   

    const handleSaveUser = async() => {
      if (!name.trim() || !mobileNo.trim() || !email.trim() || (type == "CREATE" && !password.trim()) || (type == "EDIT" && showUpdatePassword && !password.trim()) ) {
      setuserNameError(!name.trim());
      setMobileNumberError(!mobileNo.trim());
      setEmailError(!email.trim());
        setPasswordError(
          (type === "CREATE" && !password.trim()) ||
          (type === "EDIT" && showUpdatePassword && !password.trim())
        );
      let object = [
          {
              key: name.trim(),
              ref: usernameRef.current,
          },
          {
              key: mobileNo.trim(),
              ref: mobileNumberRef.current,
          },
          {
              key: email.trim(),
              ref: emailRef.current,
          }, 
          {
              key: password.trim(),
              ref: passwordRef.current,
          }
      ];
      if (type === "EDIT") {
          object = object.filter(item => item.key !== password.trim());
      }
      for (let i = 0; i < object.length; i++) {
          if (!object[i].key) {
              object[i].ref.focus();
              break;
          }
      }
          return;
      }
      setIsLoading(true);
      setIsDisabled(true);
  
      const insertData = {
        name: name.trim(),
        email: email.trim(),
        cpassword: password.trim(),
        isPwUpdate: showUpdatePassword,
        mobile_number: mobileNo,
        device_limit: deviceLimit,
        country_code: 91,
        plan_id: "",
        startDate: "",
        enddate: ""
      };

      // Conditionally add optional fields
      if (selectedStateId) insertData.state_id = selectedStateId;
      if (address?.trim()) insertData.address = address.trim();
      if (city?.trim()) insertData.city = city.trim();
      if (pincode?.trim()) insertData.pincode = pincode.trim();
  
      try {
        let response;
        if (type === "CREATE") {
          response = await createUser(insertData);
        } else {
          insertData.user_id = userId;
          insertData.status = status;
          response = await updateUser(insertData);
        }
        if (response.status) {
          toast.success(response.message);
          close();
        } else {
          toast.error(response.errorMessage);
        }
      } catch (error) {
        toast.error("Something went wrong!");
      } finally {
        setIsLoading(false);
        setIsDisabled(false);
      }
    }
  return ( 
    <Modal show={show} onHide={handleClose} dialogClassName="modal-xl">
        <Modal.Header closeButton>
        <h5 className="modal-title">{type === "CREATE" ? "Add User" : "Edit User"}</h5>
        </Modal.Header>
        <Modal.Body>
        <form className="row g-3">
             <div className="col-6 px-3">
              <label htmlFor="NewUserName" className="form-label required">User Name / School Name</label>
              <input
              id='NewUserName'
                type="text"
                className="form-control"                 
                placeholder="Enter Name"
                value={name}
                ref={usernameRef}
                maxLength={35}
                onChange={(e) => {setName(e.target.value)
                if (userNameError && e.target.value.trim() !== '') {
                      setuserNameError(false);
                }}}
              />
              <Form.Control.Feedback type="invalid" style={{ display: userNameError ? 'block' : 'none' }}>
                  User name is required
              </Form.Control.Feedback>
            </div>
            <div className="col-6 px-3">
              <label htmlFor="NewUserEmail" className="form-label required">Email</label>
              <input
                type="email"
                className="form-control"
                id="NewUserEmail"
                placeholder="Enter Email"
                value={email}
                ref={emailRef}
                maxLength={35}
                onChange={(e) => {setEmail(e.target.value)
                if (emailError && e.target.value.trim() !== '') {
                      setEmailError(false);
                }}}
              />
              <Form.Control.Feedback type="invalid" style={{ display: emailError ? 'block' : 'none' }}>
                  Email-ID is required
              </Form.Control.Feedback>
            </div>
            <div className="col-6 px-3">
              <label htmlFor="NewMobileNo" className="form-label required">Mobile Number</label>
              <input
                type="text"
                className="form-control"
                id="NewMobileNo"
                placeholder="Enter Mobile Number"
                value={mobileNo}
                ref={mobileNumberRef}
                maxLength={10}
                onChange={(e) => {setMobileNo(e.target.value)
                if (mobileNumberError && e.target.value.trim() !== '') {
                    setMobileNumberError(false);
                }}}
              />
                <Form.Control.Feedback type="invalid" style={{ display: mobileNumberError ? 'block' : 'none' }}>
                    Mobile number is required
                </Form.Control.Feedback>
            </div>{type=="CREATE" && (
             <div className="col-6 px-3">
                <label htmlFor="NewSystemUserPassword" className="form-label required">Password</label>
                {!passwordShow?(<input
                  type="password"
                  className="form-control"
                  id="NewSystemUserPassword"
                  placeholder="Enter Password"
                  value={password}
                  maxLength="35"
                  ref={passwordRef}
                  onChange={(e) => {setPassword(e.target.value)
                  if (passwordError && e.target.value.trim() !== '') {
                      setPasswordError(false);
                  }}}
                />):(<input
                  type="text"
                  className="form-control"
                  id="NewSystemUserPassword"
                  placeholder="Enter Password"
                  value={password}
                  maxLength="35"
                  ref={passwordRef}
                  onChange={(e) => {setPassword(e.target.value)
                  if (passwordError && e.target.value.trim() !== '') {
                      setPasswordError(false);
                  }}}
                />)}
                <div className="col-9 px-1">
                    <div className="form-check">
                        <input
                            autoComplete="off"
                            className="form-check-input"
                            type="checkbox"
                            id="showPassword"
                            onChange={handlePasswordShow}
                            checked={passwordShow}
                        />
                        <label htmlFor="showPassword" className="form-check-label label-grey">
                            Show password
                        </label>
                      </div>
                </div>
                <Form.Control.Feedback type="invalid" style={{ display: passwordError ? 'block' : 'none' }}>
                    Password is required
                </Form.Control.Feedback>
              </div>   )}
          <div className="col-6 px-3">
            <label htmlFor="deviceLimit" className="form-label required">Device Limit</label>
            <input
              type="number"
              className="form-control"
              id="deviceLimit"
              placeholder="Enter Device Limit"
              value={deviceLimit || 1}
              min="1"
              max="10"
              onChange={(e) => {
                const value = parseInt(e.target.value, 10);
                if (value >= 1 && value <= 10) {
                  setDeviceLimit(value);
                }
              }}
            />
          </div>
          {type === "EDIT" &&
            <div className="col-6 px-3">
              <label htmlFor="UserStatus" className="form-label required">Status</label>
              <select
                id='UserStatus'
                className="form-select"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="" disabled>Select status</option>
                <option value="true">Activate</option>
                <option value="false">Deactivate</option>
              </select>
              <div className="user-status invalid-feedback">
                Please select status.
              </div>
            </div>}
          <div className="col-6 px-3">
            <label htmlFor="userAddress" className="form-label ">Address</label>
            <input
              type="address"
              className="form-control"
              id="userAddress"
              placeholder="Enter Address"
              value={address}
              ref={addressRef}
              onChange={(e) => {setAddress(e.target.value)}}
            />
          </div>
          <div className="col-6 px-3">
            <label htmlFor="userCity" className="form-label ">City</label>
            <input
              type="text"
              className="form-control"
              id="cityInput"
              value={city}
              placeholder="Enter City"
              onChange={(e) => {setCity(e.target.value)}}
            />
          </div>
          <div className="col-6 px-3">
            <label htmlFor="userState" className="form-label ">State</label>
            <select
              className="form-control"
              id="stateSelect"
              value={selectedStateId}
              onChange={(e) => { setSelectedStateId(e.target.value) }
              }
            >
              <option value="" disabled>Select State</option>
              {stateData.map((state) => (
                <option key={state.id} value={state.id}>
                  {state.state_name}
                </option>
              ))}
            </select>
          </div>
          <div className="col-6 px-3">
            <label htmlFor="userPincode" className="form-label ">Pincode</label>
            <input
              type="text"
              className="form-control"
              id="pincodeInput"
              placeholder="Enter Pincode"
              value={pincode}
              maxLength={6}
              onChange={(e) => {setPincode(e.target.value)}}
            />
            <Form.Control.Feedback type="invalid" style={{ display: pincodeError ? 'block' : 'none' }}>
              Pincode is required
            </Form.Control.Feedback>
          </div>
          {type !== "CREATE" &&
            <div className="col-6 px-3">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="showUpdatePassword"
                  checked={showUpdatePassword}
                  onChange={(e) => setShowUpdatePassword(e.target.checked)}
                />
                <label htmlFor="showUpdatePassword" className="form-check-label">
                  Update Password
                </label>
              </div>
            </div>}
          {(type === "EDIT" && showUpdatePassword) && (
            <div className="col-6 px--6">
              <label htmlFor="NewSystemUserPassword" className="form-label required">Password</label>
              {!passwordShow ? (<input
                type="password"
                className="form-control"
                id="NewSystemUserPassword"
                maxLength="35"
                placeholder="Enter Password"
                value={password}
                ref={passwordRef}
                onChange={(e) => {
                  setPassword(e.target.value)
                  if (passwordError && e.target.value.trim() !== '') {
                    setPasswordError(false);
                  }
                }}
              />) : (<input
                type="text"
                className="form-control"
                id="NewSystemUserPassword"
                placeholder="Enter Password"
                maxLength="35"
                value={password}
                ref={passwordRef}
                onChange={(e) => {
                  setPassword(e.target.value)
                  if (passwordError && e.target.value.trim() !== '') {
                    setPasswordError(false);
                  }
                }}
              />)}
              <div className="col-9 px-1">
                <div className="form-check">
                  <input
                    autoComplete="off"
                    className="form-check-input"
                    type="checkbox"
                    id="showPassword"
                    onChange={handlePasswordShow}
                    checked={passwordShow}
                  />
                  <label htmlFor="showPassword" className="form-check-label label-grey">
                    Show password
                  </label>
                </div>
              </div>
              <Form.Control.Feedback type="invalid" style={{ display: passwordError ? 'block' : 'none' }}>
                Password is required
              </Form.Control.Feedback>
            </div>)}
          </form>    
        </Modal.Body>
        <Modal.Footer>
             <button type="button" className="btn btn-secondary" onClick={()=>handleClose()}  >
                    Close
                </button>
                <button type="button" className="btn btn-primary"onClick={()=>handleSaveUser()}  >Save</button>
           
        </Modal.Footer>
      </Modal>
       
  );
};
export default CreateUser;

 